import { PermissionService } from 'services/PermissionService';
import { Permissions } from '../../permissions';
import { getIncidentsList, getIncident, updateInicident, updateIncidentDescription, deleteIncident } from 'services/CeberusApiService';
import { Layout, Card, Icon, Button, Table, Modal, Form, Select, Input, Alert, Popconfirm } from 'antd';
import { TableCol } from 'components/TableCol';
import { Link } from 'react-router-dom';
import { AppSettings } from '../../appSettings';
import { Incident } from 'models/Blip/Incident';
import './Statuspage.scss';
import { IncidentRequest } from 'models/request/IncidentRequest';
import { Component } from 'react';
import { BaseRequest } from 'models/request/BaseRequest';
import React from 'react';
import { PushNotification } from 'utils/PushNotification';
import { UpdateIncidentDescriptionRequest } from 'models/request/Index';


const INVALID = 'Some fields are invalid, check values and try again';
const ERROR = 'Incident updated failed';
const SUCESSFULL = 'Incident updated successfully';
const UPDATE_DESCRIPTION_ERROR = 'Failed to update description';
const UPDATE_DESCRIPTION_SUCESSFULL = 'Description updated successfully';
const INCIDENT_DELETE_SUCCESS = 'Incident deleted successfully';
const INCIDENT_DELETE_FAILURE = 'Failed to delete incident';
const STATUS_PAGE_CREATE = '/statuspage/create';
const LIST_CLUSTERS = 'LIST_CLUSTERS';

export class Statuspage extends Component<BaseRequest> {

  state = {
    isLoading: false,
    incidents: [],
    canCreateIncident: PermissionService.hasPermission(Permissions.Application_Overview__Read),
    canEdit: PermissionService.hasPermission(Permissions.Application_StatusPage__Edit),
    isModalVisible: false,
    incidentEdit: '',
    messageEdit: '',
    statusEdit: '',
    setmodaldata: new Incident(),
    dataComponents: [],
    optionsValues: [],
    isDescriptionModalVisible: false,
    descriptionEdit: '',
    descriptionIncidentId: '',
    descriptionUpdateId: ''
  };

  async componentDidMount() {
    await this.onBuild();
  }

  onBuild = async () => {
    await this.verifyListCluster();
    await this.getIncidentsData();
  };

  onChange = (checked, param) => {
    const { optionsValues } = this.state;
    optionsValues[param] = checked;
    this.setState(optionsValues);
  };

  async getIncidentsData() {

    this.setState({
      isLoading: true
    });

    const incident = await getIncidentsList(new IncidentRequest(null));

    incident.map((component) => {
      let result = new Incident();
      try {
        result = this.state.dataComponents.find(x => x.key == component.incident_updates[0].affected_components[0].code);
        component.incident_updates[0].affected_components[0].name = result ? result.name : '-';
      } catch {
        result = null;
      }
    });
    this.setState({
      incidents: incident,
      isLoading: false
    });
  }

  async verifyListCluster() {
    const listComponents = [await AppSettings.get(LIST_CLUSTERS)];
    this.setState({ dataComponents: listComponents });
  }

  showModal = async (record: string) => {
    const incident = new Incident(record);
    const incidentRequest = new IncidentRequest(incident);
    this.setState({ incidentEdit: record, isModalVisible: true, setmodaldata: await getIncident(incidentRequest) });
    const body = this.state.setmodaldata.incident_updates[0].body;
    this.setState({ bodyEdit: body });
  };

  showDescriptionModal = (record) => {
    const incidentUpdate = record.incident_updates && record.incident_updates[0];
    this.setState({
      isDescriptionModalVisible: true,
      descriptionEdit: incidentUpdate.body,
      descriptionIncidentId: record.id,
      descriptionUpdateId: incidentUpdate.id,
    });
  };

  closeModal = () => {
    this.setState({ isModalVisible: false });
  };

  verifyIncidentFields() {
    return this.state.statusEdit == '' || this.state.messageEdit == '';
  };

  handleincidentStatusChange = (value) => {
    this.setState({
      statusEdit: value
    });
  };

  handleincidentMessageChange = e => {
    this.setState({
      messageEdit: e.target.value
    });
  };

  handleDescriptionSave = async () => {
    try {
      const { descriptionEdit, descriptionIncidentId, descriptionUpdateId } = this.state;

      const incidentRequest = new UpdateIncidentDescriptionRequest();
      incidentRequest.IncidentId = descriptionIncidentId;
      incidentRequest.Description = descriptionEdit;
      incidentRequest.IncidentUpdateId = descriptionUpdateId;

      await updateIncidentDescription(incidentRequest);

      this.setState({ isDescriptionModalVisible: false });
      PushNotification.success(UPDATE_DESCRIPTION_SUCESSFULL);
      window.location.reload();
    } catch (error) {
      PushNotification.error(UPDATE_DESCRIPTION_ERROR);
    }
  };

  handleDeleteIncident = async (incidentId: string) => {
    this.setState({ isLoading: true });
    try {
      const incident = new Incident();
      incident.id = incidentId;

      await deleteIncident(new IncidentRequest(incident));

      PushNotification.success(INCIDENT_DELETE_SUCCESS);
      
      await this.getIncidentsData();
    } catch (error) {
      PushNotification.error(INCIDENT_DELETE_FAILURE);
    }
    this.setState({ isLoading: false });
  };

  handleSubmit = async (e) => {
    this.setState({
      isLoading: true
    });
    if (this.verifyIncidentFields()) {
      PushNotification.error(INVALID);
    } else {
      try {
        const incident = new Incident(this.state.incidentEdit,
          this.state.setmodaldata.name,
          this.state.statusEdit,
          true,
          true,
          true,
          true,
          {},
          true,
          this.state.messageEdit,
          {},
          [this.state.setmodaldata.incident_updates[0].affected_components[0].code]
        );
        const incidentRequest = new IncidentRequest(incident);
        await updateInicident(incidentRequest);
        this.closeModal();
        PushNotification.success(SUCESSFULL);
        e.preventDefault();
        window.location.reload();
      }
      catch (error) {
        PushNotification.error(ERROR);
      }
    }
    this.setState({
      isLoading: false
    });
  }

  getUniqueComponentNames = (record) => {
    const updates = record.incident_updates || [];
    const componentNames = []
      .concat(...updates.map(update => update.affected_components || []))
      .map(component => component.name)
      .filter(name => typeof name === 'string' && name.trim().length > 0 && name !== '-');

    return Array.from(new Set(componentNames));
  };

  getUniqueClusterNames = (record): string[] => {
    const clusterList = AppSettings.get("LIST_CLUSTERS") || [];

    const keyToNameMap = clusterList.reduce((map, item) => {
      if (item.key && item.name) {
        map[item.key] = item.name;
      }
      return map;
    }, {});

    const updates = record.incident_updates || [];
    const affectedComponents = updates.flatMap(update => update.affected_components || []);

    const clusterNames = affectedComponents
      .map(component => keyToNameMap[component.code])
      .filter(name => typeof name === 'string' && name.trim().length > 0);

    return Array.from(new Set(clusterNames));
  };

  render() {

    const otherColumns = [
      TableCol({
        title: 'Name',
        dataIndex: 'name',
        sort: (a, b) => a.name.localeCompare(b.name),
        filter: (value, record) => record.name.toString().includes(value.toString()),
      }),
      TableCol({
        title: 'Description',
        dataIndex: 'incident_updates[0].body',
        render: (_, record) => {
          const body = record.incident_updates[0].body || '-';
          return (
            <div>
              <p style={{ marginBottom: '8px' }}>{body}</p>
              <Button type="primary" size="small" icon="edit" shape="round" disabled={!this.state.canEdit} onClick={() => this.showDescriptionModal(record)}>Edit</Button>
            </div>
          );
        },
        filter: (value, record) =>
          record.incident_updates[0].body.toString().includes(value.toString()),
      }),
      TableCol({
        title: 'Status',
        dataIndex: 'status',
        sort: (a, b) => a.status.localeCompare(b.status),
        filter: (value, record) => record.status.toString().includes(value.toString()),
      }),
      TableCol({
        title: 'Created Date',
        dataIndex: 'created_at',
        sort: (a, b) => a.created_at.localeCompare(b.created_at),
        filter: (value, record) => record.created_at.toString().includes(value.toString()),
      }),
      TableCol({
        title: 'Cluster',
        dataIndex: 'incident_updates[0].affected_components[0].component_id',
        render: (_, record) => {
          const names = this.getUniqueClusterNames(record);
          return names.length > 0 ? names.join(', ') : '-';
        },
        sort: (a, b) => {
          const aName = this.getUniqueClusterNames(a).join(', ');
          const bName = this.getUniqueClusterNames(b).join(', ');
          return aName.localeCompare(bName);
        },
        filter: (value, record) => {
          const names = this.getUniqueClusterNames(record);
          return names.some(name => name.toLowerCase().includes((value as string).toLowerCase()));
        }
      }),
      TableCol({
        title: 'Component',
        dataIndex: 'components[0].name',
        render: (_, record) => {
          const names = this.getUniqueComponentNames(record);
          return names.join(', ') || '-';
        },
        sort: (a, b) => {
          return this.getUniqueComponentNames(a).join(', ').localeCompare(
            this.getUniqueComponentNames(b).join(', '));
        },
        filter: (value, record) => {
          return this.getUniqueComponentNames(record).some(name => name.includes(value));
        }
      }),
      TableCol({
        title: 'Update Date',
        dataIndex: 'updated_at',
        sort: (a, b) => a.updated_at.localeCompare(b.updated_at),
        filter: (value, record) => record.updated_at.toString().includes(value.toString()),
      }),
      TableCol({
        title: 'Actions',
        dataIndex: 'id',
        render: (id, record) => (
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button
              type="primary"
              disabled={!this.state.canEdit}
              onClick={() => this.showModal(id)}
            >
              Edit
            </Button>
            <Popconfirm
              title="Are you sure you want to delete this incident?"
              onConfirm={() => this.handleDeleteIncident(id)}
              okText="Yes"
              cancelText="No"
              disabled={!this.state.canEdit}
            >
              <Button type="danger" disabled={!this.state.canEdit}>
                Delete
              </Button>
            </Popconfirm>
          </div>
        )
      }),
    ];
    return (
      <>
        <div className='create-incident-button'>
          <div className='ant-btn tc ant-btn-primary ant-btn-lg'>
            {this.state.canCreateIncident ? (
              <Button type="primary">
                <Link to={STATUS_PAGE_CREATE}>
                  Create Incident
                  <Icon type="alert" />
                </Link>
              </Button>
            ) : null
            }
          </div>
        </div>
        <div>
          <Layout.Content className="body-incidents">
            <Card title="Incidents" className="mb3">
              <Table columns={otherColumns} dataSource={this.state.incidents} rowKey="id" bordered loading={this.state.isLoading} />
            </Card>
          </Layout.Content>
        </div>
        <Modal title="Update incident"
          visible={this.state.isModalVisible}
          onCancel={this.closeModal}
          footer={[
            <Button key="back" onClick={this.closeModal}>
              Cancel
            </Button>,
            <Popconfirm
              key="confirm"
              title="This action may update the incident status and message. Are you sure you want to proceed?"
              onConfirm={this.handleSubmit}
              okText="Yes"
              cancelText="No"
            >
              <Button type="primary" loading={this.state.isLoading}>
                Update Incident
              </Button>
            </Popconfirm>,
          ]}>
          <Form name="basic"
          >
            <p><b>Name:</b> {this.state.setmodaldata.name}</p>
            <p><b>Actual Status:</b> {this.state.setmodaldata.status}</p>
            <Form.Item label="New Incident Status" required={true}>
              <Select
                placeholder="Select a option and change input text above"
                allowClear
                onChange={this.handleincidentStatusChange}>
                <Select.Option value="investigating">Investigating</Select.Option>
                <Select.Option value="identified">Identified</Select.Option>
                <Select.Option value="monitoring">Monitoring</Select.Option>
                <Select.Option value="resolved">Resolved</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item required={true}>
              <Input.TextArea
                maxLength={1000}
                value={this.state.messageEdit}
                onChange={this.handleincidentMessageChange}
                allowClear />
            </Form.Item>
          </Form>
          <Alert
            message="Careful!"
            description="This action may update the incident status and message."
            type="warning"
            showIcon
          />
        </Modal>
        <Modal
          title="Edit Incident Description"
          visible={this.state.isDescriptionModalVisible}
          onCancel={() => this.setState({ isDescriptionModalVisible: false })}
          footer={[
            <Button key="cancel" onClick={() => this.setState({ isDescriptionModalVisible: false })}>
              Cancel
            </Button>,
            <Button key="save" type="primary" onClick={this.handleDescriptionSave}>
              Save
            </Button>,
          ]}
        >
          <Form layout="vertical">
            <Form.Item label="Description">
              <Input.TextArea
                rows={4}
                value={this.state.descriptionEdit}
                onChange={(e) => this.setState({ descriptionEdit: e.target.value })}
              />
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  }
}
